import { type AuthToken } from '@reliance/types/models/Auth';
import {
  type Category,
  type Item,
  type Order,
} from '@reliance/types/models/Commissary';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import {
  type ApiSuccessResponse,
  type ApiService,
  type QueryParams,
} from '../types/ApiService';

export const commissary = (
  centralApi: ApiService,
  getToken: () => AuthToken,
) => ({
  category: {
    index: (params: QueryParams = {}): Promise<PaginatedResponse<Category>> => {
      return centralApi.get('/commissary/category', { params });
    },
    post: (data: object): Promise<ApiSuccessResponse<void>> => {
      return centralApi.post('/commissary/category', data, {
        contentType: false,
      });
    },
    put: async (
      id: FormDataEntryValue | null,
      data: FormData,
    ): Promise<ApiSuccessResponse<void>> => {
      if (data.get('categoryPhoto[0]')) {
        await centralApi.post(`/commissary/category/${id}/photo`, data, {
          contentType: false,
        });
      }
      return centralApi.put(`/commissary/category/${id}`, {
        name: data.get('name'),
      });
    },
  },
  item: {
    index: (params: QueryParams = {}): Promise<PaginatedResponse<Item>> => {
      return centralApi.get('/commissary/item', { params });
    },
    post: (data: object): Promise<ApiSuccessResponse<void>> => {
      return centralApi.post('/commissary/item', data, {
        contentType: false,
      });
    },
    put: async (
      id: FormDataEntryValue | null,
      data: FormData,
    ): Promise<ApiSuccessResponse<void>> => {
      if (data.get('itemPhoto[0]')) {
        await centralApi.post(`/commissary/item/${id}/photo`, data, {
          contentType: false,
        });
      }
      return centralApi.put(`/commissary/item/${id}`, {
        name: data.get('name'),
        description: data.get('description'),
        price: data.get('price'),
        itemNumber: data.get('itemNumber'),
        billingCategory: data.get('billingCategory'),
        active: data.get('active'),
      });
    },
  },
  order: {
    get: (id: number): Promise<Order> => {
      return centralApi.get<Order>('/commissary/order/' + id);
    },
    index: (params: QueryParams = {}): Promise<PaginatedResponse<Order>> => {
      return centralApi.get('/commissary/order', { params });
    },
    pdfUrl: (ids: string) => {
      return centralApi.buildUrl('/commissary/order.pdf', {
        ids,
        token: getToken().accessToken,
      });
    },
  },
});
